// 为每个淘宝表单控件提供vuex中的淘宝的一些方法
import { mapGetters, mapActions } from 'vuex'

export default {
  inject: ['alibabaFormVm'],
  data() {
    return {
      options: [],
      isAsyncOptions: false,
    }
  },
  watch: {
    props: {
      immediate: true,
      handler: function (v) {
        if (!v || !v.dataSource) return;
        const { options, label } = v.dataSource;
        this.options = (options || []).map(item => ({ ...item, pLabel: label }))
      }
    }
  },
  computed: {
    ...mapGetters(['alibabaForm', 'alibabaData', 'alibabaSpecifications', 'alibabaSkuList', 'alibabaOptions', 'alibabaHasOption', 'shops_defaultShopId', 'shops_getById', 'shops_updateShopId', 'shops_updateIndex', 'shops_all', 'shops_getCategoryPropShopId', 'removePureItem']),
    key() {
      return this.props.name
    },
    secondary() {
      return this.alibabaFormVm?.catPropSecondaryList?.length && this.props?.dataSource?.parentName === 'catProp'
    },
  },
  methods: {
    ...mapActions(['initAlibabaForm', 'updateAlibabaForm', 'initAlibabaOptions', 'updateAlibabaSpecifications', 'updateAlibabaSkuList']),
  }
}

